// extracted by mini-css-extract-plugin
module.exports = {"warningModal":"warning-modal_warningModal__1dfe8"};